<template>
  <div class="login-auth-container auth-container">
    <back-btn
      dark
      v-if="0"
      :class="{ 'hidden': !authType || authType === 'playphone-last-step' }"
      :should-pop="$route.params.type !== 'reset'"
      :back-route="{ name: 'login' }"
      :text="$t('auth.back')"
    />
    <auth-methods :params="params" :authType="authType" @changeAuthType="changeAuthType" @authenticated="goToBrowse" />
  </div>
</template>

<script>
export default {
  name: 'login-auth-container',
  props: {
    authType: String
  },
  data: () => ({
    params: {}
  }),
  methods: {
    changeAuthType(type, params, replace) {
      this.params = params || {}
      const query = { ...this.$route.query }
      const route = type
        ? { name: 'login', params: { type, ...this.params }, query }
        : { path: '/login', query }

      if (replace) {
        this.$router.replace(route)
      } else {
        this.$router.push(route)
      }
    },
    goToBrowse() {
      // Do not pass `/login/:type?` params into `browse` — extras can break route resolution and
      // leave the app on `/login` while Vuex is already authenticated (same rule as Viu post-login).
      const query = { ...this.$route.query }
      delete query.hash
      delete query.he_hash
      this.$router.push({ name: 'browse', query })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-auth-container {
  display: flex;
  flex-direction: column;
}
</style>
